<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-title>
                <v-switch
                    v-model="published"
                    :label="publishedText"
                />
                <v-spacer />
                <v-radio-group
                    dense
                    v-model="level"
                    row
                >
                    <v-radio
                        label="Basic"
                        value="basic"
                        dense
                    />
                    <v-radio
                        label="Premium"
                        value="premium"
                        dense
                    />
                    <v-radio
                        label="Plus"
                        value="plus"
                        dense
                    />
                </v-radio-group>
            </v-card-title>
            <v-card-text>
                <form
                    action=""
                    method="POST"
                    @submit.prevent="save"
                >
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="name"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    id="name"
                                    v-model="name"
                                    outlined
                                    :error-messages="errors[0]"
                                    @change="createSlug"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="slug"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Slug"
                                    name="slug"
                                    id="slug"
                                    v-model="slug"
                                    outlined
                                    :error-messages="errors[0]"
                                    :readonly="slugReadonly"
                                    :aria-readonly="slugReadonly"
                                    :disabled="slugReadonly"
                                >
                                    <template
                                        #append-outer
                                        v-if="slug && slug !== ''"
                                    >
                                        <v-btn
                                            small
                                            icon
                                            @click="editSlug"
                                        >
                                            <v-icon small>
                                                fas fa-edit
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="subtitle"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Subtitle"
                                    name="title"
                                    id="subtitle"
                                    v-model="subtitle"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="order"
                                rules="integer"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Order"
                                    name="order"
                                    id="order"
                                    v-model="order"
                                    outlined
                                    :error-messages="errors[0]"
                                    type="number"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    text
                    @click="toggleDeleteModal(true)"
                    :disabled="invalid || cards.length > 0"
                >
                    <span v-if="cards.length > 0 ">Remove attached cards to delete page</span>
                    <span v-else>Delete Page</span>
                </v-btn>
                <v-spacer />
                <v-btn
                    type="submit"
                    color="primary"
                    @click="save"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import store from '../../../../store/store';
import slugify from '@/helpers/slugify';

export default {

    computed: {
        name: {
            get: function() {
                return store.state.pageEditor.name;
            },
            set: function(value) {
                this.setName(value);
            }
        },

        slug: {
            get: function() {
                return store.state.pageEditor.slug;
            },
            set: function(value) {
                this.setSlug(value);
            }
        },

        order: {
            get: function() {
                return store.state.pageEditor.order;
            },
            set: function(value) {
                this.setOrder(value);
            }
        },

        published: {
            get: function() {
                return store.state.pageEditor.published;
            },
            set: function(value) {
                this.setPublished(value);
            }
        },

        subtitle: {
            get: function() {
                return store.state.pageEditor.subtitle;
            },
            set: function(value) {
                this.setSubtitle(value);
            }
        },

        level: {
            get: function() {
                return store.state.pageEditor.level;
            },
            set: function(value) {
                this.setLevel(value);
            }
        },

        ...mapState('pageEditor', ['deleteModal', 'cards']),

        ...mapGetters({
            publishedText: 'pageEditor/publishedText'
        })
    },

    data() {
        return {
            slugReadonly: true,
        };
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'pageEditor/getData',
            saveData: 'pageEditor/saveData',
            destroyData: 'pageEditor/destroyData'
        }),

        ...mapMutations({
            toggleOverlay: 'overlay/toggle',
            setId: 'pageEditor/setPageId',
            setName: 'pageEditor/setName',
            setSlug: 'pageEditor/setSlug',
            setOrder: 'pageEditor/setOrder',
            setSubtitle: 'pageEditor/setSubtitle',
            setPublished: 'pageEditor/setPublished',
            setLevel: 'pageEditor/setLevel',
            toggleDeleteModal: 'pageEditor/toggleDeleteModal'
        }),

        save() {
            this.saveData();
        },

        createSlug() {
            if (!this.slug) {
                this.slug = slugify(this.name);
            }
        },

        editSlug() {
            this.slugReadonly = false;
        },

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
